import React from "react";
import styled from "styled-components";
import { variant } from "styled-system";
import Icon from "../icons/Icon";
import { apolloFontFamilyBody, apolloFontFamilyBodySmall, apolloFontSizeBody, apolloFontSizeBodySmall, apolloFontSizeBodyXlarge, apolloFontWeightBody, apolloFontWeightBodySmall, apolloLineHeightBody, apolloLineHeightBodySmall, apolloSpaceInset1X, apolloSpaceInset2X, apolloSpaceInset3X, apolloSpaceInset4X, apolloSpaceInsetHalfX, } from "@nexthink/apollo-tokens";
import Error from "@nexthink/apollo-tokens/lib/images/react/Error";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import apolloTheme from "../../theme/Theme";
export const StyledErrorIcon = styled(Error).withConfig({ displayName: "StyledErrorIcon_APC-7311-productShell", componentId: "sc-zky1fj" })(({ theme }) => ({
    color: theme.colors.apolloColorStrokeError,
    width: apolloSpaceInset2X,
}));
export const StyledErrorIconContainer = styled.span.withConfig({ displayName: "StyledErrorIconContainer_APC-7311-productShell", componentId: "sc-1p6eutg" })(({ hasSuffix }) => ({
    marginRight: hasSuffix ? apolloSpaceInset3X : apolloSpaceInset1X,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: "auto",
    right: 0,
    height: "16px",
    width: "16px",
}));
export const StyledInput = styled.input.withConfig({ displayName: "StyledInput_APC-7311-productShell", componentId: "sc-1mrj26h" })(({ theme, suffix, prefix, error, readOnly }) => {
    const paddingRight = getValueFromPixelString(suffix ? apolloSpaceInset4X : apolloSpaceInset1X) +
        getValueFromPixelString(error ? apolloSpaceInset3X : "0px");
    const paddingRightFocus = getValueFromPixelString(suffix ? apolloSpaceInset4X : apolloSpaceInset1X) +
        getValueFromPixelString(error ? apolloSpaceInset3X : "0px") -
        1;
    const paddingLeftFocus = getValueFromPixelString(prefix ? apolloSpaceInset4X : apolloSpaceInset1X) - 1;
    return Object.assign(Object.assign({ background: theme.colors.apolloColorBackgroundFormElementDefault, border: `1px solid ${theme.colors.apolloColorStrokeFormElementDefault}`, borderRadius: apolloSpaceInsetHalfX, boxSizing: "border-box", color: theme.colors.apolloColorTextPrimary, padding: `0 ${paddingRight}px 0 ${prefix ? apolloSpaceInset4X : apolloSpaceInset1X}`, width: "100%", "&:hover": {
            borderColor: theme.colors.apolloColorStrokeFormElementHover,
        }, "&::placeholder": Object.assign({ color: theme.colors.apolloColorTextTertiary }, apolloTheme.textStyles.bodyEmphasis), "&::-ms-clear": {
            display: "none",
        }, "&:-ms-input-placeholder": {
            color: `${theme.colors.apolloColorTextTertiary} !important`,
        }, "&:focus-visible": {
            border: `2px solid ${theme.colors.apolloColorStrokeFocus} !important`,
            padding: `0 ${paddingRightFocus}px 0 ${paddingLeftFocus}px`,
            outline: "none",
        }, "&&:disabled": {
            background: theme.colors.apolloColorBackgroundFormElementDisabled,
            borderColor: theme.colors.apolloColorStrokeFormElementDisabled || theme.colors.apolloColorBackgroundFormElementDisabled,
            color: theme.colors.apolloColorTextDisabled,
        } }, (error && {
        "&&": {
            borderColor: theme.colors.apolloColorStrokeError,
        },
        // error border is more important than hover but less important than focus
        "&:hover": {
            borderColor: theme.colors.apolloColorStrokeError,
        },
    })), (readOnly && {
        background: theme.colors.apolloColorBackgroundFormElementReadonly,
        borderColor: theme.colors.apolloColorBackgroundFormElementReadonly,
        cursor: "text",
        color: theme.colors.apolloColorTextPrimary,
        "&:hover": {
            borderColor: theme.colors.apolloColorBackgroundFormElementReadonly,
        },
    }));
}, variant({
    variants: {
        normal: {
            font: `${apolloFontWeightBodySmall} ${apolloFontSizeBodySmall}/${apolloLineHeightBodySmall} ${apolloFontFamilyBodySmall}`,
            height: apolloSpaceInset3X,
        },
        large: {
            font: `${apolloFontWeightBody} ${apolloFontSizeBody}/${apolloLineHeightBody} ${apolloFontFamilyBody}`,
            height: apolloSpaceInset4X,
        },
    },
}));
export const StyledIcon = styled(({ icon, className }) => (React.createElement(Icon, { name: icon, className: className }))).withConfig({ displayName: "StyledIcon_APC-7311-productShell", componentId: "sc-1bc8s1z" })(({ theme, position }) => (Object.assign(Object.assign({ color: theme.colors.apolloColorTextTertiary, fontSize: apolloFontSizeBodyXlarge, left: 0, padding: `0 ${apolloSpaceInset1X}`, position: "absolute", top: "50%", transform: "translateY(-50%)" }, (position === "suffix" && {
    left: "auto",
    right: 0,
})), { width: "16px !important" })));
//# sourceMappingURL=Input.style.js.map